/**
 * Donate monthly journey steps
 */
import { Navigate, Outlet } from 'react-router-dom';

import { getCurrencySymbol } from '@/locale';
import JourneyContainer from '@/services/journeys/JourneyContainer';
import ProvidersLibsContainer from '@/services/providersLibs/ProvidersLibsContainer';

import PaymentSelect from '@/features/paymentSelect/PaymentSelect';
import UserDetails from '@/features/userDetails/UserDetails';
import GocardlessPayment from '@/providers/gocardless/GocardlessPayment';
import GocardlessConfirmation from '@/providers/gocardless/GocardlessConfirmation';
import PaymentSuccess from '@/features/paymentProcess/PaymentSuccess';
import PaymentSubmitted from '@/features/paymentProcess/PaymentSubmitted';
import PaymentFailure from '@/features/paymentProcess/PaymentFailure';
import PaymentError from '@/features/paymentProcess/PaymentError';

const currencySymbol = getCurrencySymbol();
const monthlyRouteSteps = 5;

const donateMonthlyRoutes = {
  path: '/donate-monthly',
  element: (
    <ProvidersLibsContainer>
      <JourneyContainer journey="monthly">
        <Outlet />
      </JourneyContainer>
    </ProvidersLibsContainer>
  ),
  children: [
    // Redirect from "/donate-monthly" index to "./payment-select"
    {
      path: '',
      element: <Navigate to="./payment-select" replace />,
    },
    {
      path: 'payment-select',
      element: <PaymentSelect
        providerGroup="monthly"
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'user-details',
      element: <UserDetails
        providerGroup="monthly"
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'bank-payment',
      element: <GocardlessPayment
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'bank-confirmation',
      element: <GocardlessConfirmation
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'success',
      element: <PaymentSuccess
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'submitted',
      element: <PaymentSubmitted
        totalSteps={monthlyRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'failure',
      element: <PaymentFailure />,
    },
    {
      path: 'error',
      element: <PaymentError />,
    },
  ],
};

export default donateMonthlyRoutes;
